import { render, staticRenderFns } from "./MKIImpact.vue?vue&type=template&id=840110c2&scoped=true"
import script from "./MKIImpact.vue?vue&type=script&lang=js"
export * from "./MKIImpact.vue?vue&type=script&lang=js"
import style0 from "./MKIImpact.vue?vue&type=style&index=0&id=840110c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840110c2",
  null
  
)

export default component.exports